import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-home-input-slider',
  templateUrl: './home-input-slider.component.html',
  styleUrls: ['./home-input-slider.component.scss']
})
export class HomeInputSliderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
